import { useState, useEffect } from "react";

export function useMediaQuery(query) {
	// Initialize with a check for SSR (server-side rendering)
	const getMatches = (query) => {
		// Check if window exists (not in SSR)
		if (typeof window !== "undefined") {
			return window.matchMedia(query).matches;
		}
		return false;
	};

	const [matches, setMatches] = useState(getMatches(query));

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);

		// Initial check
		setMatches(mediaQuery.matches);

		// Create an event listener
		const handleChange = (event) => {
			setMatches(event.matches);
		};

		// Modern way of adding the listener
		mediaQuery.addEventListener("change", handleChange);

		// Clean up
		return () => {
			mediaQuery.removeEventListener("change", handleChange);
		};
	}, [query]);

	return matches;
}
